<template>
  <div id="app">
    <Header />
      <main id="fh5co-dedicated-services" class="top-section" data-section="dedicated-services">
        <div class="container">
          <div class="section-heading text-center">
            <h2>Serviços dedicados</h2>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="products-container">
                <Produto url="/servicos-dedicados/areas-dedicadas.html" name="Áreas Dedicadas" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Conectividade">Conexão full time com as principais operadoras do mercado nacional e com a internet.</ProductBenefit>
                    <ProductBenefit title="Estabilidade">Infraestrutura com fornecimento de energia e refrigeração ininterruptas.</ProductBenefit>
                    <ProductBenefit title="Segurança">Acesso biométrico ao ambiente e Circuito Fechado de Televisão (CFTV).</ProductBenefit>
                    <ProductBenefit title="Customização">Contratação de racks, cages ou salas dedicadas, com infraestrutura customizada.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto url="/servicos-dedicados/colocation.html" name="Colocation" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Facilidade">Atendimento especializado e completo: todo cliente que entra em contato com a EBS é atendido por um técnico qualificado, que acompanhará seu chamado do início ao fim do processo – sem call center ou qualquer outro intermediário.</ProductBenefit>
                    <ProductBenefit title="Segurança">Todas as operações da EBS são certificadas. E, como a empresa é conhecida por suas boas práticas, cada cliente passa a ter chances maiores de obter sua própria certificação se auditar o ambiente de TI.</ProductBenefit>
                    <ProductBenefit title="Compliance">A EBS regularmente passa por auditorias independentes para certificar-se de que todos os processos são seguidos corretamente e para manter o nível elevado da segurança da informação, potencializando a proteção de seus dados e reduzindo as chances de perdas e custos operacionais.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto url="/servicos-dedicados/datacenters.html" name="Datacenters" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Autonomia">Você mesmo define as características do seu projeto sob medida.</ProductBenefit>
                    <ProductBenefit title="Economia ">Investimento inicial reduzido, com terceirização da construção e operação de facilities.</ProductBenefit>
                    <ProductBenefit title="Segurança">Monitoramento com Circuito Fechado de Televisão (CFTV) dedicado e controle de acesso exclusivo.</ProductBenefit>
                    <ProductBenefit title="Compliance">Adequação às normas e certificações necessárias ao negócio.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto url="/servicos-dedicados/hosting.html" name="Hosting" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Customização">Servidores e conectividade que atendem às necessidades específicas de carga de trabalho da sua empresa, garantindo que mais serviços usem os recursos corretos.</ProductBenefit>
                    <ProductBenefit title="Lucratividade">Estabilidade nos pagamentos, previsibilidade para o crescimento e blindagem contra oscilações de câmbio.</ProductBenefit>
                    <ProductBenefit title="Facilidade">Contratação de equipamentos e licenças como serviço, sem se preocupar com renovações e prazos. As informações de licenciamento são centralizadas em um único fornecedor.</ProductBenefit>
                    <ProductBenefit title="Simplicidade">Sem necessidade de assinar um contrato de suporte com fabricantes de hardware ou de utilizar mão de obra especializada na área.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto href="/servicos-dedicados/racks-dedicados.html" name="Racks Dedicados" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Conectividade">Conexão com as principais operadoras do mercado nacional e com a internet.</ProductBenefit>
                    <ProductBenefit title="Estabilidade">Infraestrutura com fornecimento de energia ininterrupta, refrigeração e cabling terceirizados.</ProductBenefit>
                    <ProductBenefit title="Flexibilidade">Autonomia para alteração das posições físicas de equipamentos dentro dos racks.</ProductBenefit>
                    <ProductBenefit title="Controle">Servidores e equipamentos de rede com segurança e total controle de acesso.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto url="/servicos-dedicados/remote-hands.html" name="Remote Hands" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Controle">Acompanhamento de fabricantes e manutenção dos equipamentos instalados no ambiente de Colocation.</ProductBenefit>
                    <ProductBenefit title="Agilidade">Informações em tempo real sobre as características físicas locais do ambiente instalado nos racks.</ProductBenefit>
                    <ProductBenefit title="Tranquilidade">Você terá a certeza de sempre contar com profissionais capacitados para atendê-lo em casos de emergência.</ProductBenefit>
                    <ProductBenefit title="Facilidade">Facilidade - Problemas técnicos resolvidos com eficiência, sem necessidade de deslocamento até o local.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto url="/servicos-dedicados/smart-hands.html" name="Smart Hands" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Qualificação">Equipes especializadas e multidisciplinares para prestação de suporte 24x7x365.</ProductBenefit>
                    <ProductBenefit title="Economia">Sem custo de contratação de pessoal: o pagamento é mensal na modalidade “serviço”.</ProductBenefit>
                    <ProductBenefit title="Tranquilidade">Você terá a certeza de sempre contar com profissionais capacitados para atendê-lo em casos de emergência.</ProductBenefit>
                    <ProductBenefit title="Facilidade ">Problemas técnicos resolvidos com eficiência, sem necessidade de deslocamento até o local.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
                <Produto url="/servicos-dedicados/work-area.html" name="Work Area" callToAction="saiba mais">
                  <ProductBenefits>
                    <ProductBenefit title="Privacidade">Sua Work Área pode ser de uso restrito ou compartilhado.</ProductBenefit>
                    <ProductBenefit title="Agilidade">Acesso rápido aos equipamentos hospedados no Data Center.</ProductBenefit>
                    <ProductBenefit title="Continuidade">Seus funcionários estratégicos seguirão trabalhando, mesmo com um problema físico no escritório.</ProductBenefit>
                    <ProductBenefit title="Flexibilidade">Ambientes preparados para receber pequenas e grandes equipes.</ProductBenefit>
                  </ProductBenefits>
                </Produto>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer/>
  </div>
</template>

<style>
#fh5co-header #navbar li a {
  color: rgba(0, 0, 0, 0.5);
}

#fh5co-header #navbar li a:hover{
  color: #52d3aa;
}

#fh5co-header .navbar-brand {
  color: #52d3aa;
}

table#draas-table {
  margin: 1.5em auto;
}
#draas-table th, td {
  padding: 12px 15px 12px 0;
}
</style>

<script>
import Header from './header.vue'
import Footer from './footer.vue'
import ProductBenefits from './productBenefits.vue'
import ProductBenefit from './productBenefit.vue'
import Produto from './home/produto.vue'

export default {
  name: 'ServicosDedicados',
  components: {
    Header,
    Footer,
    ProductBenefits,
    ProductBenefit,
    Produto
  }
}
</script>
